module.exports = __webpack_public_path__ + "img/report-3.f81c825b.jpg";